export default __webpack_public_path__ + "static/media/empty_bookings.d271e631.svg";